import React from 'react';
import { FadeIn } from './FadeIn';
export function HowItWorks() {
  const steps = ['Escucha el audiolibro y comprende por qué tu cuerpo ha estado acumulando grasa.', 'Implementa el protocolo de 14 días para apagar la inflamación y equilibrar tu glucosa.', 'Recupera tu energía y nota cómo tu ropa vuelve a quedarte cómoda, sin pasar hambre ni agotarte.'];
  return <section className="py-24 px-6 bg-white" data-id="element-121">
      <div className="max-w-4xl mx-auto" data-id="element-122">
        <FadeIn data-id="element-123">
          <h2 className="font-serif text-3xl md:text-4xl text-charcoal mb-16 text-center" data-id="element-124">
            Cómo funciona
          </h2>
          <div className="space-y-12" data-id="element-125">
            {steps.map((step, idx) => <div key={idx} className="flex flex-col md:flex-row items-center md:items-start gap-6 md:gap-8 text-center md:text-left" data-id="element-126">
                <div className="w-16 h-16 rounded-full bg-sage/20 text-sage font-serif text-3xl flex items-center justify-center shrink-0" data-id="element-127">
                  {idx + 1}
                </div>
                <p className="font-sans text-xl text-charcoal/80 leading-relaxed pt-2" data-id="element-128">
                  {step}
                </p>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}